module.exports = __webpack_public_path__ + "media/img/frontend_application/visa-970e33550a33c7f39543f4dabde0cab4.svg";